import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Route guard for admin/management routes
 * Requires authentication + admin-level permissions (members:write, events:write, etc.)
 * Or Owner role (wildcard permissions)
 */
const AdminRoute: React.FC = () => {
  const { isAuthenticated, isLoading, isOwner, isAdmin, isSuperAdmin } = useAuth();

  // Show loading state while auth is initializing
  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  // Not authenticated - redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check for admin-level access via role type or super admin (impersonation)
  const hasAdminAccess = isOwner || isAdmin || isSuperAdmin;

  if (!hasAdminAccess) {
    // User is authenticated but doesn't have admin permissions
    // Redirect to user dashboard instead
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
